import { BaseAPI } from "../base/service";
import { CourseType } from "../enums";
import { HandoutResolution } from "./dto";

export class HandoutResolutionAPI extends BaseAPI {
    private year = new Date().getFullYear();

    public getList(courseType: CourseType): Promise<HandoutResolution[]> {
        return this.api.get(`/${courseType}/${this.year}/handout-resolution/`);
    }
}